import { ReactNode, useMemo } from 'react';

type Props = {
  value: string | string[] | null | undefined;
  labelIcon?: ReactNode;
  onClick: () => void;
};

export const AreaSelect = ({ value, labelIcon, onClick }: Props) => {
  const selectedValueText = useMemo(() => {
    const text = typeof value === 'string' ? value : value?.join(', ') || '';

    return text.length > 14 ? `${text.substr(0, 14)} ...` : text;
  }, [value]);

  return (
    <>
      <div className="select-wrapper flex">
        <div>
          <div className="mt-1">{labelIcon && <span className="select-label-icon-wrapper">{labelIcon}</span>}</div>
        </div>
        <div className="ml-3" onClick={onClick}>
          {value && value.length > 0 ? <span>{selectedValueText}</span> : <span>エリアを選択</span>}
        </div>
        <style jsx>{`
          .select-wrapper {
            width: 80%;
          }
          // TODO PC版を実装するまでの一時的な対応 https://github.com/spotmate/baitry-worker-frontend-ssr/issues/155
          @media (min-width: 800px) {
            .area-select {
              width: 100%;
              max-width: 1022px;
            }
            .select-wrapper {
              width: 100%;
            }
            .select-label-wrapper {
              width: 10%;
            }
            .select-input-wrapper {
              width: 100%;
            }
          }
        `}</style>
      </div>
    </>
  );
};
